export default "__VITE_ASSET__Da$e1XTb__";